<ng-template #messageTemplate>
  <tr>
    <td [attr.colspan]="colSpan" align="center">
      <vnm-empty-message
        [icon]="icon"
        [loadingIcon]="loadingIcon"
        [loadingMessage]="loadingMessage"
        [loading]="loading"
        [message]="message"
      ></vnm-empty-message>
      <ng-content></ng-content>
    </td>
  </tr>
</ng-template>
